import React from "react";

export default function DepartmentSelect({
  id,
  ariaLabel,
  departments = [],
  value = "",
  disabled = false,
  onChange
}) {
  const isDisabled = disabled || departments.length === 0;

  return (
    <select
      id={id}
      aria-label={ariaLabel}
      value={value}
      disabled={isDisabled}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value="">Select dept</option>
      {departments.map((department) => (
        <option
          key={department.departmentId ?? `dept-${department.name}`}
          value={department.name}
        >
          {department.name}
        </option>
      ))}
    </select>
  );
}
